import { 
    utils,
    config
} from "../../../../studentportal-sdk"

export const getAllUsers = async() => {
    try{
        const {data} = await utils.apiConnect().get(config.domains.endpoints.getUsersApi)

        return {
            status: true,
            data: data.data,
            message: ''
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const getStudents = async() => {
    try{
        const {data} = await utils.apiConnect().get(config.domains.endpoints.getStudentsApi)

        return {
            status: true,
            data: data.data,
            message: ''
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const userAccountSignIn = async ({ email, password, authProvider }) => {
    try {
        const {
            data,
        } = await utils.apiConnect().post(config.domains.endpoints.postUserAccountSignInApi, {
            email, 
            password,
            authProvider
        });
        return {
            status: true,
            data: data.data,
            message: ''
        }
    } catch (error) {
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const userAccountSignUp = async ({ 
    email,
    firstname,
    lastname,
    password,
    confirmPassword,
    category,
    group,
    phone,
    isBaptised
}) => {
    try {
        const {
            data
        } = await utils.apiConnect().post(config.domains.endpoints.postUserAccountSignUpApi, {
            email,
            firstname,
            lastname,
            password,
            confirmPassword,
            category,
            group,
            phone,
            isBaptised
        });
        return {
            status: true,
            data: data.data,
            message: ''
        }
    } catch (error) {
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}


export const userAccountEmailVerfication = async (formdata) => {
    try{
        const {data} = await utils.apiConnect().post(config.domains.endpoints.postUserEmailVerification, formdata);
        return {
            status: true,
            message: data.message
        }
    } catch (error) {
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const verifyToken = async (formdata) => {
    try{
        const {data} = await utils.apiConnect().get(config.domains.endpoints.getVerifyToken +`?token=${formdata.token}`);
        return {
            status: true,
            data: data.data,
            message: ''
        }
    } catch (error) {
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const resetPassword = async (formdata) => {
    try{
        const {data} = await utils.apiConnect().put(config.domains.endpoints.updateResetPassword, formdata);
        return {
            status: true,
            data: data.data,
            message: ''
        }
    } catch (error) {
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}